import { render, staticRenderFns } from "./Tema6.vue?vue&type=template&id=4d88b547&scoped=true&lang=pug&"
import script from "./Tema6.vue?vue&type=script&lang=js&"
export * from "./Tema6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88b547",
  null
  
)

export default component.exports